/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class SaveNotebookContentRequest {
  'content': { [key: string]: any; };

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "content",
      "baseName": "content",
      "type": "{ [key: string]: any; }",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SaveNotebookContentRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

